import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import React from "react";

interface ButtonTypeProps {
  isSelected: boolean;
  onClick?: () => void;
  title: string;
  isMovile: boolean;
  width: string;
  widthMoviles: string;
  height: string;
  heightMoviles: string;
  padding?: string | number;
  icon?: string;
  width_icon?: string;
  height_icon?: string;
  font_size_movil?: string;
  font_size?: string;
  top_icon?: string;
  // Colores personalizables (opcionales)
  bgColor?: string;
  bgColorActive?: string;
  textColor?: string;
  textColorActive?: string;
  borderColorActive?: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
  borderColor?: string;
  // Borde inactivo y peso de fuente
  borderWidth?: string;
  borderStyle?: string;
  font_weight?: string | number;
}

const StyledButtonWrapper = styled(Box)({
  position: "relative",
  display: "inline-block",
});

// 👇️ props filtradas del DOM usando shouldForwardProp
const StyledPersonButton = styled(Button, {
  shouldForwardProp: (prop) =>
    ![
      "selected",
      "isMovile",
      "width",
      "widthMoviles",
      "height",
      "heightMoviles",
      "padding",
      "font_size_movil",
      "font_size",
      // props de color personalizadas
      "bgColor",
      "bgColorActive",
      "textColor",
      "textColorActive",
      "borderColorActive",
      "hoverBgColor",
      "hoverTextColor",
      "borderColor",
      // borde inactivo y font-weight
      "borderWidth",
      "borderStyle",
      "font_weight",
    ].includes(prop as string),
})<{
  selected: boolean;
  isMovile: boolean;
  width: string;
  widthMoviles: string;
  height: string;
  heightMoviles: string;
  padding?: string | number;
  font_size: string;
  font_size_movil: string;
  bgColor?: string;
  bgColorActive?: string;
  textColor?: string;
  textColorActive?: string;
  borderColorActive?: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
  borderColor?: string;
  borderWidth?: string;
  borderStyle?: string;
  font_weight?: string | number;
}>(
  ({
    selected,
    isMovile,
    width,
    widthMoviles,
    height,
    heightMoviles,
    padding,
    theme,
    font_size_movil,
    font_size,
    bgColor,
    bgColorActive,
    textColor,
    textColorActive,
    borderColorActive,
    borderColor,
    borderWidth,
    borderStyle,
    font_weight,
    hoverBgColor,
    hoverTextColor,
  }) => ({
    position: "relative",
    zIndex: 1,
    width: isMovile ? widthMoviles : width,
    height: isMovile ? heightMoviles : height,
    minWidth: 0,
    padding: padding ?? 0,
    lineHeight: 1,
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    backgroundColor: selected
      ? bgColorActive ?? theme?.palette?.components?.buttonSelect?.backgroundColorActive
      : bgColor ?? theme?.palette?.components?.buttonSelect?.backgroundColor,
    color: selected
      ? textColorActive ?? theme?.palette?.components?.buttonSelect?.textColorActive
      : textColor ?? theme?.palette?.components?.buttonSelect?.textColor,
    border: selected
      ? `2px solid ${borderColorActive ?? theme?.palette?.components?.buttonSelect?.bordeColorActive}`
      : `${borderWidth ?? "2px"} ${borderStyle ?? "solid"} ${borderColor ?? "transparent"}`,
    boxShadow: selected ? "2px 4px 10px rgba(200, 150, 150, 0.4)" : "none",
    textTransform: "none",
    fontSize: isMovile ? font_size_movil : font_size,
    fontWeight: font_weight ?? 400,
    "&:hover": {
      backgroundColor: hoverBgColor ?? theme?.palette?.components?.buttonSelect?.backgroundColorActive,
      color: hoverTextColor ?? theme?.palette?.components?.buttonSelect?.textColorActive,
    },
  }),
);

const CheckImage = styled("img", {
  shouldForwardProp: (prop) => prop !== "top_icon",
})<{
  top_icon?: string;
}>(({ top_icon }) => ({
  position: "absolute",
  top: top_icon || "-16px",
  left: "calc(50% - 12px)",
  borderRadius: "50%",
  padding: "0px",
  zIndex: 2,
}));

export const ButtonTypeSelectedCustom: React.FC<ButtonTypeProps> = ({
  isSelected,
  onClick,
  title,
  isMovile,
  height,
  heightMoviles,
  width,
  widthMoviles,
  icon,
  width_icon,
  height_icon,
  padding,
  font_size = "14px",
  font_size_movil = "11px",
  top_icon,
  bgColor,
  bgColorActive,
  textColor,
  textColorActive,
  borderColorActive,
  hoverBgColor,
  hoverTextColor,
  borderColor,
  borderWidth,
  borderStyle,
  font_weight,
}) => {
  return (
    <StyledButtonWrapper>
      {isSelected && icon && (
        <CheckImage src={icon} alt="Seleccionado" width={width_icon} height={height_icon} top_icon={top_icon} />
      )}
      <StyledPersonButton
        selected={isSelected}
        onClick={onClick}
        isMovile={isMovile}
        height={height}
        heightMoviles={heightMoviles}
        width={width}
        widthMoviles={widthMoviles}
        padding={padding}
        font_size={font_size}
        font_size_movil={font_size_movil}
        bgColor={bgColor}
        bgColorActive={bgColorActive}
        textColor={textColor}
        textColorActive={textColorActive}
        borderColorActive={borderColorActive}
        hoverBgColor={hoverBgColor}
        hoverTextColor={hoverTextColor}
        borderColor={borderColor}
        borderWidth={borderWidth}
        borderStyle={borderStyle}
        font_weight={font_weight}
      >
        {title}
      </StyledPersonButton>
    </StyledButtonWrapper>
  );
};
